import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
String.prototype.titleCase = function () {
  return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

ReactDOM.render(<App />, document.getElementById('root'))
